import moment from "moment-timezone";
window.updateStoreOpenStatus = updateStoreOpenStatus;

$(function () {
    updateStoreOpenStatus()
    updateStoreOpenStatusSingle();
});

function checkStoreOpenStatus(e) {
    let timezone = e.find(".store-day-hours-container").data("store-time-zone"),
        dateformat = "hh:mm a",
        dateObj = moment.tz(timezone),
        day_span = e.find(".store-day-hours .day")[dateObj.day() - 1];
    if (!day_span) return false;
    let is_closed = day_span.getAttribute("data-closed"),
        open_time = day_span.getAttribute("data-open"),
        close_time = day_span.getAttribute("data-close"),
        s = moment(open_time, dateformat),
        b = moment(close_time, dateformat),
        l = dateObj.format(dateformat),
        M = moment(l, dateformat);
    return { day: day_span, open: "false" === is_closed && M.isBetween(s, b) };
}
function updateStoreOpenStatus() {
    $("#storeListWrapper")
        .find(".store-card")
        .each(function () {
            let e = checkStoreOpenStatus($(this)).open,
                t = $(this).find(".store-card-store-hours-status-badge");
            if (e) {
                let o = t.data("opentext") || "Open Now";
                t.addClass("store-card-store-hours-status-badge_open").html(o);
            } else {
                let n = t.data("closetext") || "Closed";
                t.addClass("store-card-store-hours-status-badge_close").html(n);
            }
        });
}

function updateStoreOpenStatusSingle() {
    $(".store-detail").each(function () {
        let e = checkStoreOpenStatus($(this)).open,
            t = $(this).find(".store-card-store-hours-status-badge");
        if (e) {
            let o = t.data("opentext") || "Open Now";
            t.addClass("store-card-store-hours-status-badge_open").html(o);
        } else {
            let n = t.data("closetext") || "Closed";
            t.addClass("store-card-store-hours-status-badge_close").html(n);
        }
    });
}